import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { DialogModule } from 'primeng/dialog';

@Component({
  selector: 'app-file-preview-dialog',
  standalone: true,
  imports: [DialogModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <p-dialog
      [header]="fileName"
      [visible]="visible"
      (visibleChange)="visibleChange.emit($event)"
      [modal]="true"
      [style]="{ width: '80vw', maxWidth: '900px' }"
      [dismissableMask]="true"
    >
      <div style="display: flex; justify-content: center; padding: 1rem 0">
        @if (mimeType === 'image') {
          <img
            [src]="url"
            [alt]="fileName"
            style="max-width: 100%; max-height: 70vh; object-fit: contain"
          />
        }
      </div>
    </p-dialog>
  `,
})
export class FilePreviewDialog {
  @Input() visible = false;
  @Input() fileName = '';
  @Input() mimeType = '';
  @Input() url = '';
  @Output() visibleChange = new EventEmitter<boolean>();
}
